/**
 * Route: /people/:id — person-detail.html (v2-Relaunch, People-Merge)
 *
 * Kanonisches Ziel fuer die Person-Detail-Seite (SPEC.md: "person-detail.html
 * | /people/:id | people/:id, settlements by person"). Es gibt noch keinen
 * /api/v2/people/{id}-Endpunkt (Backlog #4) — :id ist die Contact-ID;
 * ContactDetailPage merged den passenden Host client-seitig ueber die
 * E-Mail-Adresse (siehe useMatchedHost dort). Host-only Personen (kein
 * Contact mit derselben E-Mail) bleiben vorerst unter /hosts/:id — eigene
 * Seite ausserhalb dieses Auftrags (person-detail-Fix, siehe Ergebnis).
 */
import { createFileRoute } from '@tanstack/react-router'
import { ContactDetailPage } from '../features/contacts/ContactDetailPage'

export const Route = createFileRoute('/_auth/people/$id')({
  component: function PersonDetailRoute() {
    const { id } = Route.useParams()
    return <ContactDetailPage id={id} />
  },
})
